import axiosPost from "./axiosPost";

export const MerchantBODetalleGet= async (credentials, merchantId) => {
    const body = {
        service: "MerchantBODetalleGet",
        params: {
            merchantId: merchantId,
        },
    };    
    try {
        
        const response = await axiosPost("Y", body, credentials)
        return response;
    } catch (err) {
        console.error(`Error: ${err}`);
    }
}